'use strict';

angular.module("cimerFrontEndApp")
    .controller("BaseSurveyCtrl", ["$scope", "$q", "SurveyService", "Session", "$uibModal", "$routeParams", "AdministratorService", "$location", "TextEditorService", "idFactory", "$http", "ApiUrl", function ($scope, $q, SurveyService, Session, $uibModal, $routeParams, AdministratorService, $location, TextEditorService, idFactory, $http, ApiUrl) {

        var adminPageUrl = '/baseSurveys';  

        var sessionObject = Session.getSessionObject();
        if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isProjectAdmin)) {
            $location.url('/');
            return;
        }

        var divisionID = $routeParams.divisionID;
        if (!divisionID) {
            $location.url(adminPageUrl); 
            return;
        }


        //set up empty model
        $scope.showPage = false;
        $scope.showCompositeScore = false;
        $scope.showBaseSurveyForm = false;
        $scope.copiedDivision = null;
        $scope.copyProject = null;
        $scope.divisions = [];
        $scope.baseSurvey = {
            surveyName: "",
            infoText: "",
            sections: [],
            TargetID: null
        };
        $scope.compositeScores = [];
        $scope.tinymceOptions = TextEditorService.GetTextEditorConfig();
        $scope.sortableOptions = {
            handle: '.section-drag-and-drop',
        };
        $scope.surveyNameMaxLength = 255;
        $scope.surveyDescriptionMaxLength = 5000;

        var dataRequests = [AdministratorService.GetDivisionByID(divisionID), SurveyService.getTargets()];
        //load requested data
        $q.all(dataRequests)
            .then(function (data) {
                $scope.division = data[0];
                $scope.targets = data[1];
            });

        var loadBaseSurveyForEdit = function (surveyID) {
            SurveyService.isBaseSurveyEditable(surveyID)
                .then(function (result) {
                    if (result) {
                        SurveyService.getSurveyForEdit(surveyID)
                            .then(function (result) {
                                $scope.baseSurvey.surveyName = result.Name;
                                $scope.baseSurvey.infoText = result.InfoText;
                                $scope.baseSurvey.TargetID = result.TargetID;
                                $scope.baseSurvey.SurveyID = result.SurveyID;
                                var tempObj = {};
                                for (var i = 0; i < result.Sections.length; i++) {
                                    tempObj = {
                                        sectionName: result.Sections[i].SectionText,
                                        SectionID: result.Sections[i].SectionID,
                                        SectionRoleID: result.Sections[i].SectionRoleID,
                                        questions: SurveyService
                                            .parseQuestionPrompts(result.Sections[i].QuestionPrompts),
                                        Validated: result.Sections[i].Validated,
                                        collapse: false // default all the sections to being open on load
                                    };
                                    $scope.baseSurvey.sections.push(tempObj);
                                }

                                $scope.copiedDivision = divisionID;
                                $scope.showPage = true;
                                $scope.showCompositeScore = false;
                                $scope.showBaseSurveyForm = true;
                            });
                    } else {
                        $location.url(adminPageUrl);
                    }
                },
                    function () {
                        $location.url(adminPageUrl);
                    });
        };

        if ($routeParams.hasOwnProperty("edit")) {
            var surveyID = $routeParams.edit;
            loadBaseSurveyForEdit(surveyID);

        }
        else if ($routeParams.hasOwnProperty("copy")) {
            $scope.copySurveyID = $routeParams.copy;
            // get the projects
            $http.get(ApiUrl.url('/Project/') + 'GetProjectsWhereUserIsAdmin')
                .then(function (response) {
                    $scope.projects = response.data;
                    $scope.showPage = true;
                    $scope.showCompositeScore = false;
                    $scope.showBaseSurveyForm = false;  // set this to true after a project and division are selected
                });
        }
        else if ($routeParams.hasOwnProperty("editCompScore")) {
            var compScoreSurveyID = $routeParams.editCompScore;
            SurveyService.getBaseCompositeScoresForEdit(compScoreSurveyID)
                    .then(function (result) {

                        $scope.baseSurvey.surveyName = result.Name;
                        $scope.baseSurvey.SurveyID = result.SurveyID;
                        var tempObj = {};
                        for (var i = 0; i < result.CompositeScores.length; i++) {
                            tempObj = {
                                compositeScoreName: result.CompositeScores[i].Name,
                                compositeScoreID: result.CompositeScores[i].CompositeScoreID,
                                allQuestions: SurveyService.parseQuestionsForCompositeScore(result.CompositeScores[i].AllQuestions),
                                selectedQuestions: SurveyService.parseQuestionsForCompositeScore(result.CompositeScores[i].SelectedQuestions)
                            };
                            $scope.compositeScores.push(tempObj);
                        }
                        $scope.copiedDivision = divisionID;
                        $scope.showPage = true;
                        $scope.showCompositeScore = true;
                        $scope.showBaseSurveyForm = false;
                    });
        }
        else {
            $scope.copiedDivision = divisionID;
            $scope.showPage = true;
            $scope.showCompositeScore = false;
            $scope.showBaseSurveyForm = true;
        }

        $scope.changeDivision = function (copiedDivision) {
            if (copiedDivision) {
                divisionID = copiedDivision.DivisionID;
                $scope.copySurvey($scope.copySurveyID);
            }
        };

        $scope.getDivisions = function (project) {
            $http.get(ApiUrl.url('/Division/') + 'Divisions/' + project.ProjectId)
                .then(function (response) {
                    $scope.divisions = response.data;
                });
        };

        $scope.selectProject = function () {
            if (!$scope.copyProject) {
                $scope.divisions = [];
            }
            else {
                $scope.getDivisions($scope.copyProject);
            }
        };

        $scope.copySurvey = function (surveyID) {
            // reset the base survey just in case
            $scope.baseSurvey = {
                surveyName: "",
                infoText: "",
                sections: [],
                TargetID: null
            };
            SurveyService.getSurveyForCopy(surveyID)
                .then(function (result) {
                    $scope.baseSurvey.surveyName = result.Name;
                    $scope.baseSurvey.infoText = result.InfoText;
                    $scope.baseSurvey.TargetID = result.TargetID;
                    $scope.baseSurvey.SurveyID = result.SurveyID;
                    var tempObj = {};
                    for (var i = 0; i < result.Sections.length; i++) {
                        tempObj = {
                            sectionName: result.Sections[i].SectionText,
                            SectionID: result.Sections[i].SectionID,
                            SectionRoleID: result.Sections[i].SectionRoleID,
                            questions: SurveyService.parseQuestionPrompts(result.Sections[i].QuestionPrompts),
                            Validated: result.Sections[i].Validated,
                            collapse: false // default all the sections to being open on load
                        };
                        // Assign temp IDs to questions and scale answers
                        for (var j = 0; j < tempObj.questions.length; j++) {
                            if (tempObj.questions[j].typeID === 0) { // need another loop for matrix questions
                                var matrixQuestions = tempObj.questions[j].details.Questions;
                                var matrixScale = matrixQuestions[0].QuestionScale;
                                for (var k = 0; k < matrixScale.length; k++) {
                                    // Matrix questions all share the same scale, so assign IDs to the first question's scale, then copy that scale to all the others
                                    matrixScale[k].tempID = idFactory.getNewScaleAnswerID();
                                }
                                for (var l = 0; l < matrixQuestions.length; l++) {
                                    matrixQuestions[l].tempID = idFactory.getNewQuestionID();
                                    matrixQuestions[l].QuestionScale = matrixQuestions[0].QuestionScale;
                                }
                            }
                            else {
                                tempObj.questions[j].details.tempID = idFactory.getNewQuestionID();
                                if (tempObj.questions[j].typeID !== 3) // don't set temp ID for text question scale
                                {
                                    for (var m = 0; m < tempObj.questions[j].details.QuestionScale.length; m++) {
                                        tempObj.questions[j].details.QuestionScale[m].tempID = idFactory.getNewScaleAnswerID();
                                    }
                                }
                            }
                        }
                        $scope.baseSurvey.sections.push(tempObj);
                    }
                    $scope.showBaseSurveyForm = true;
                });
        };

        $scope.addNewSection = function() {
            if (!$scope.baseSurvey.hasOwnProperty('sections') || $scope.baseSurvey.sections === undefined) {
                $scope.baseSurvey.sections = [];
            }
            $scope.baseSurvey.sections.push({
                sectionName: '<p>Add new section name here</p>', // placeholder text
                SectionRoleID: 1, // base section role
                questions: [],
                Validated: false,
                collapse: false
            });
        };

        $scope.removeSection = function(index) {
            $scope.baseSurvey.sections.splice(index, 1);
        };

        $scope.cancelSurveyCreation = function()
        {
            $location.url(adminPageUrl);
        };

        $scope.cancelEditCompositeScore = function () {
            $scope.compositeScores = [];
            $location.url(adminPageUrl);
        };

        $scope.previewSurvey = function () {
            var survey = {};
            var tempObj = {};

            survey.SurveyName = $scope.baseSurvey.surveyName;
            survey.Sections = [];
            var questionCount = 1;

            //add custom Sections and renumber for newly added questions
            for (var i = 0; i < $scope.baseSurvey.sections.length; i++) {
                tempObj = {
                    SectionTitle: $scope.baseSurvey.surveyName,
                    SectionText: $scope.baseSurvey.sections[i].sectionName,
                    SectionSortOrder: i,
                    QuestionPrompts: [],
                    Validated: $scope.baseSurvey.sections[i].Validated
                };
                for (var j = 0; j < $scope.baseSurvey.sections[i].questions.length; j++) {
                    $scope.baseSurvey.sections[i].questions[j].details.questionCount = questionCount;
                    if ($scope.baseSurvey.sections[i].questions[j].details.hasOwnProperty('Questions')) {
                        for (var k = 0; k < $scope.baseSurvey.sections[i].questions[j].details.Questions.length; k++) {
                            $scope.baseSurvey.sections[i].questions[j].details.Questions[k].promptCount = k + 1;
                        }
                    }
                    tempObj.QuestionPrompts.push($scope.baseSurvey.sections[i].questions[j].details);
                    questionCount++;
                }
                survey.Sections.push(tempObj);
            }



            var previewSurveyModalInstance = $uibModal.open({
                animation: true,
                templateUrl: '/Content/Templates/survey/previewSurveyModal.html',
                controller: 'PreviewSurveyModalCtrl',
                size: 'lg',
                resolve: {
                    survey: function () {
                        return survey;
                    }
                }
            });
        };

        $scope.addCompositeScore = function () {
            if (!$scope.hasOwnProperty('compositeScores') || $scope.compositeScores === undefined) {
                $scope.compositeScores = [];
            }
            SurveyService.getBaseQuestionsForCompositeScore($scope.baseSurvey.SurveyID)
                .then(function (result) {
                    $scope.compositeScores.push({
                        compositeScoreName: '',
                        selectedQuestions: [],
                        allQuestions: SurveyService.parseQuestionsForCompositeScore(result)
                    });
                });
        };

        $scope.removeCompositeScore = function (index) {
            $scope.compositeScores.splice(index, 1);
        };

        //save the survey here
        $scope.formSubmitted = false;
        var getSurveyForSave = function() {

            $scope.formSubmitted = true;

            if (!$scope.baseSurveyForm.$invalid) { // we can submit
                var survey = {};
                var tempObj = {};
                var tempQuestion = {};
                var question = {};
                var sortOrder = 0;
                var sectionID = null;

                survey.Name = $scope.baseSurvey.surveyName;
                if ($scope.baseSurvey.hasOwnProperty('SurveyID')) { //EDIT existing survey
                    survey.SurveyID = $scope.baseSurvey.SurveyID;
                }
                else { //SAVE new survey with known base survey
                    survey.SurveyID = null;
                }

                survey.TargetID = $scope.baseSurvey.TargetID;
                survey.OwningUserID = null; //base surveys are not owned
                survey.InfoText = $scope.baseSurvey.infoText;
                survey.Sections = [];
                survey.DivisionID = parseInt(divisionID);  //base surveys are assigned to a specific division

                //add sections
                for (var i = 0; i < $scope.baseSurvey.sections.length; i++) {
                    if ($scope.baseSurvey.sections[i].hasOwnProperty('SectionID')) { //existing section
                        sectionID = $scope.baseSurvey.sections[i].SectionID;
                    }
                    else { // new section
                        sectionID = null;
                    }
                    tempObj = {
                        SectionID: sectionID,
                        SectionTitle: $scope.baseSurvey.surveyName,
                        SectionText: $scope.baseSurvey.sections[i].sectionName,
                        SectionSortOrder: i + 1,
                        SectionRoleID: 1, //base section 
                        Questions: [],
                        Validated: $scope.baseSurvey.sections[i].Validated
                    };
                    sortOrder = 1;
                    for (var j = 0; j < $scope.baseSurvey.sections[i].questions.length; j++) {

                        //if it is a matrix question, need another loop
                        if ($scope.baseSurvey.sections[i].questions[j].details.hasOwnProperty('Questions')) {
                            //this is matrix survey item 
                            for (var k = 0; k < $scope.baseSurvey.sections[i].questions[j].details.Questions.length; k++) {
                                question = $scope.baseSurvey.sections[i].questions[j].details.Questions[k];
                                tempQuestion = {
                                    QuestionID: question.QuestionID,
                                    SectionIndexID: question.SectionIndexID,
                                    SortOrder: sortOrder,
                                    TargetID: survey.TargetID,
                                    QuestionScale: {
                                        QuestionScaleID: question.QuestionScaleID,
                                        OwnerID: null, //no owner for base surveys
                                        Answers: question.QuestionScale
                                    },
                                    QuestionTypeID: question.QuestionTypeID,
                                    Text: question.Text,
                                    QuestionLabel: question.QuestionLabel,
                                    QuestionPromptID: $scope.baseSurvey.sections[i].questions[j].details.QuestionPromptID,
                                    QuestionPromptText: $scope.baseSurvey.sections[i].questions[j].details.QuestionPromptText,
                                    QuestionRoleID: SurveyService.QuestionRole.Base, //base question
                                    QuestionBranchIDs: [],
                                    MatrixQuestionGroup: j.toString(), //current matrix group. The backend maps this to a string property for some reason
                                    Required: false
                                };
                                // Add all the question branch IDs to the question
                                for (var l = 0; l < question.QuestionBranches.length; l++) {
                                    for (var m = 0; m < question.QuestionBranches[l].ParentQuestions.length; m++) {
                                        tempQuestion.QuestionBranchIDs.push(question.QuestionBranches[l].ParentQuestions[m].ScaleAnswers.map(sa => sa.QuestionBranch.getID().toString()));
                                    }
                                }
                                tempQuestion.QuestionBranchIDs = tempQuestion.QuestionBranchIDs.flat();
                                // Don't need to update scale answers here because matrix questions can't be parents
                                tempObj.Questions.push(tempQuestion);
                                sortOrder++;
                            }
                        }
                        //otherwise just add the question
                        else {
                            question = $scope.baseSurvey.sections[i].questions[j].details;
                            tempQuestion = {
                                QuestionID: question.QuestionID,
                                SectionIndexID: question.SectionIndexID,
                                SortOrder: sortOrder,
                                TargetID: survey.TargetID,
                                QuestionScale: {
                                    QuestionScaleID: question.QuestionScaleID,
                                    OwnerID: null, //no owner for base surveys
                                    Answers: question.QuestionScale
                                },
                                QuestionTypeID: question.QuestionTypeID,
                                Text: question.Text,
                                QuestionLabel: question.QuestionLabel,
                                QuestionPromptID: question.QuestionPromptID,
                                QuestionPromptText: '',
                                QuestionRoleID: SurveyService.QuestionRole.Base, //base question
                                QuestionBranchIDs: [],
                                MatrixQuestionGroup: null,
                                Required: question.Required
                            };
                            // Add all the question branch IDs to the question
                            for (var n = 0; n < question.QuestionBranches.length; n++) {
                                for (var o = 0; o < question.QuestionBranches[n].ParentQuestions.length; o++) {
                                    tempQuestion.QuestionBranchIDs.push(question.QuestionBranches[n].ParentQuestions[o].ScaleAnswers.map(sa => sa.QuestionBranch.getID().toString()));
                                }
                            }
                            tempQuestion.QuestionBranchIDs = tempQuestion.QuestionBranchIDs.flat();
                            // Add branch IDs to scale objects
                            for (n = 0; n < question.QuestionScale.length; n++) {
                                tempQuestion.QuestionScale.Answers[n].TempBranchID = question.QuestionScale[n].QuestionBranch.TempBranchID;
                            }
                            tempObj.Questions.push(tempQuestion);
                            sortOrder++;
                        }
                    }
                    survey.Sections.push(tempObj);
                } //end add sections

                return survey;

            } else { return null; } // invalid survey form
            
        }; // end getSurveyForSave


        $scope.saveBaseSurvey = function (exitAfterSave) {
            $scope.formSubmitted = true;
            if ($scope.baseSurveyForm.$invalid) {
                return; // Don't let them save, the page will display the errors for them
            }
            var survey = getSurveyForSave();
            SurveyService.saveBaseSurvey(survey).then(function (result) {
                if (!exitAfterSave) {
                    $scope.formSubmitted = false; // reset this variable so errors don't show immediately as the user is adding new things 
                    // Reset the survey object in preparation for reload
                    $scope.baseSurvey = {
                        surveyName: "",
                        infoText: "",
                        sections: [],
                        TargetID: null
                    };
                    // Reload the survey to update IDs and everything
                    loadBaseSurveyForEdit(result);
                }
                else {
                    //strip query parameter
                    if ($location.$$search.edit) {
                        delete $location.$$search.edit;
                        $location.$$compose();
                    }
                    if ($location.$$search.copy) {
                        delete $location.$$search.copy;
                        $location.$$compose();
                    }
                    $location.url(adminPageUrl);
                }
            });
        };


        $scope.saveCompositeScores = function () {

            $scope.formSubmitted = true;

            if (!$scope.compositeScoresForm.$invalid) { // we can submit
                // format for save
                var surveyCompositeScore = {
                    BaseSurveyID: $scope.baseSurvey.SurveyID,
                    CompositeScores: []
                };
                var tempObj = {};
                var tempQuestion = {};
                for (var i = 0; i < $scope.compositeScores.length; i++) {
                    var compositeScore = $scope.compositeScores[i];
                    tempObj = {
                        CompositeScoreID: compositeScore.compositeScoreID,
                        Name: compositeScore.compositeScoreName,
                        Questions: []
                    };
                    for (var j = 0; j < compositeScore.selectedQuestions.length; j++) {
                        tempQuestion = {
                            QuestionID: compositeScore.selectedQuestions[j].details.QuestionID
                        };
                        tempObj.Questions.push(tempQuestion);
                    }
                    surveyCompositeScore.CompositeScores.push(tempObj);
                }

                //submit composite scores
                SurveyService.saveBaseCompositeScores(surveyCompositeScore).then(function (result) {
                    //strip query parameter
                    if ($location.$$search.editCompScore) {
                        delete $location.$$search.editCompScore;
                        $location.$$compose();
                    }
                    $location.url(adminPageUrl);
                }, function (err) {
                    $location.path('error');
                });

            }
        };

    }]);